import { debounce, isEqual } from 'lodash';
import { Form } from 'connex-cds';
import React from 'react';
import { useTicketContext } from './TicketContext';
const EDITABLE_EVENTS = [
  'PRINTED',
  'LOADING_STARTED',
  'LOADING_COMPLETE',
  'TO_JOB',
  'ARRIVE_JOB',
  'UNLOADING',
  'END_UNLOADING',
  'WASHING',
  'END_WASHING',
  'LEAVE_JOB',
  'IN_YARD',
  'PUMPING_STARTED',
  'PUMPING_COMPLETE',
  'READY_TO_PUMP',
];

export const RefreshMonitor = ({ children }) => {
  const { ticket } = useTicketContext();
  const { values, setFieldValue } = Form.useFormContext();

  React.useEffect(() => {
    const nextTicketEvents = { ...(values?.ticketEvents || {}) };

    Object.keys(ticket?.ticketEvents || {}).forEach(key => {
      if (!EDITABLE_EVENTS.includes(key)) {
        return;
      }

      nextTicketEvents[key] = {
        ...(ticket?.ticketEvents?.[key] || {}),
        ...(nextTicketEvents?.[key] || {}),
        eventDateTime: nextTicketEvents?.[key]?.eventDateTime || ticket?.ticketEvents?.[key]?.eventDateTime,
      };
    });

    const updateValues = debounce(() => {
      setFieldValue('ticketEvents', nextTicketEvents);
    }, 1000);

    if (!isEqual(nextTicketEvents, values?.ticketEvents || {})) {
      updateValues();
    }
  }, [setFieldValue, ticket?.ticketEvents, values?.ticketEvents]);

  return children;
};
